<template>
  <vue-scroll>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-select
          v-model="value"
          placeholder="Selecciones un rango"
          @change="handleChangeCustomer"
          size="mini"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="6">
        <el-select
          v-model="DaySelected"
          placeholder="Dias del mes"
          filterable
          clearable
          @change="DaySelectedFuntion"
          style="float: right; margin-left: 10px"
          size="mini"
        >
          <el-option
            v-for="item in days"
            :key="item.Dias"
            :label="item.DiaDelMes"
            :value="item.Dias"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedMonth"
          placeholder="Seleccione un mes"
          @change="handlermonth"
          size="mini"
        >
          <el-option
            v-for="(month, index) in months"
            :key="index"
            :label="month.label"
            :value="month.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <YearsComponent
          ref="yearSelector"
          @change="handleryear"
          :initial="2014"
          :max="yearMax"
          class="box-item"
          size="large"
          v-model="year"
        />
      </el-col>
    </el-row>

    <RabbeyTable3
      :columns="columns"
      :data="items"
      style="margin: 20px"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />
  </vue-scroll>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
//import RenderCheckLabelRequired from "@/components/functionals/RenderCheckLabelRequired.vue";
import YearsComponent from "@/components/Global_System/YearsComponent.vue";
const yearNow = new Date().getFullYear();
//const month = new Date().getMonth();

export default {
  name: "GpsOfflines.vue",
  components: {
    RabbeyTable3,
    YearsComponent
  },
  data() {
    return {
      DaySelected: null,
      months: [
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" }
      ],
      selectedMonth: "",
      year: yearNow,
      yearMax: yearNow,
      options: [
        {
          value: "0-5",
          label: "0-5 Dias Desconectado"
        },
        {
          value: "6-15",
          label: "6-15 Dias Desconectado"
        },
        {
          value: "16-30",
          label: "15-30 Dias Desconectado"
        },
        {
          value: "31-60",
          label: "30-60 Dias Desconectado"
        },
        {
          value: ">60",
          label: "Mas de 60 Dias Desconectado"
        }
      ],
      value: "0-5",
      columns: [
        {
          prop: "id",
          label: "Id GPS",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "label",
          label: "Descripcion del Gps",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "connectionstatus",
          label: "Estatus",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "creationdate",
          label: "Fecha de Creacion",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "lastconnectiondate",
          label: "Ultima conexion",
          fixed: true,
          minWidth: 200
        },
        {
          prop: "daysOffline",
          label: "Dias Desconectado",
          fixed: true,
          minWidth: 200
        }
      ],
      items: [],
      fileList: []
    };
  },
  created() {
    console.log("resp");

    this.getgpsofflines();
  },
  methods: {
    getgpsofflines() {
      this.$http
        .get("/api/navixy/GetReportGpfNavixy", {
          timeout: 3 * 60 * 1000,
          params: {
            month: this.selectedMonth,
            DAYSOFF: this.value,
            year: this.year,
            day: this.DaySelected
          }
        })
        .then((resp) => {
          this.items = resp.data;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    handleChangeCustomer() {
      this.getgpsofflines();
    },
    handleryear(_year) {
      this.year = _year;
      this.getgpsofflines();
    },
    handlermonth() {
      this.getgpsofflines();
      this.getdays();
    },
    getdays() {
      this.$http
        .get(`/api/SalesApi/DaybyMonth?datetime=${this.selectedMonth}`)
        .then((resp) => {
          this.days = resp.data;
        });
    },
    DaySelectedFuntion() {
      this.getgpsofflines();
    }
  }
};
</script>
